import { NoteIcon } from '@/components/icons';
import { isObjectEmpty } from '@/helpers/helper';
import { useNote } from '@/context/NoteProvider';
import { Box, Grid2, Typography } from '@mui/material';
import EmptyState from './EmptyState';
import ErrorState from './ErrorState';
import LoadingState from './LoadingState';
import NoteDisplay from './NoteDisplay';
import { rightPanelStyles } from './styles';

const RightPanel = () => {
  const noteContext = useNote();

  // Only show error when the HISTORY context is in error state
  const noteError = noteContext.status === 'error';

  // Check if we have a complete note with content
  const hasNote = noteContext.currentNote && 
    !isObjectEmpty(noteContext.currentNote) &&
    Object.keys(noteContext.currentNote).filter(key =>
      key.toLowerCase().includes('text')
    ).length > 0;

  // Show loading when creating or polling for notes
  const shouldShowLoading = noteContext.isLoading && !hasNote;

  return (
    <Grid2 size={{ xs: 12, lg: 6 }} sx={rightPanelStyles.container}>
      <Box sx={rightPanelStyles.card}>
        {!shouldShowLoading && !hasNote && (
          <Box sx={rightPanelStyles.header}>
            <Box sx={rightPanelStyles.iconContainer}>
              <NoteIcon width={28} height={28} />
            </Box>
            <Typography variant="h4" sx={rightPanelStyles.headerTitle}>
              Generated notes
            </Typography>
          </Box>
        )}
        {/* Loading State */}
        {shouldShowLoading && <LoadingState />}

        {/* Error State */}
        {noteError && <ErrorState />}

        {/* Note Display */}
        {hasNote && !shouldShowLoading && <NoteDisplay />}

        {/* Empty State */}
        {!hasNote && !shouldShowLoading && !noteError && <EmptyState />}
      </Box>
    </Grid2>
  );
};

export default RightPanel;
